import memoize from 'lodash/memoize'
import { ContextApi } from 'contexts/Localization/types'
import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
  title: 'ZSwap',
  description:
    'The up-and-coming AMM on Avalanche! Earn ZAP tokens by yield farming or through faction-v-faction competitions, then stake them to earn even more tokens!',
  image: 'https://zswap.plus/images/hero.png',
}

interface PathList {
  paths: { [path: string]: { title: string; basePath?: boolean; description?: string } }
  defaultTitleSuffix: string
}

const getPathList = (t: ContextApi['t']): PathList => {
  return {
    paths: {
      '/': { title: t('Home'), description: 'Swap, farm, stake and win crypto with the ZSwap decentralized exchange! The future home of crypto on AVAX.' },
      '/swap': { basePath: true, title: t('Swap'), description: 'Swap tokens quickly and easily with the ZSwap Decentralized Exchange.' },
      '/add': { basePath: true, title: t('Add V2 Liquidity'), description: 'Add liquidity for your favourite tokens to earn rewards.' },
      '/remove': { basePath: true, title: t('Remove Liquidity') },
      '/liquidity': { title: t('Liquidity') },
      '/find': { title: t('Import Pool') },
      '/bridge': { basePath: true, title: t('Bridge') },
      '/competition': { title: t('Trading Battle') },
      '/prediction': { title: t('Prediction') },
      '/prediction/leaderboard': { title: t('Leaderboard') },
      '/farms': { title: t('Farms') },
      '/farms/auction': { title: t('Farm Auctions') },
      '/pools': { title: t('Pools') },
      '/lottery': { title: t('Lottery') },
      '/ifo': { title: t('Initial Farm Offering') },
      '/teams': { basePath: true, title: t('Leaderboard') },
      '/voting': { basePath: true, title: t('Voting') },
      '/voting/proposal': { title: t('Proposals') },
      '/voting/proposal/create': { title: t('Make a Proposal') },
      '/info': { title: t('Overview'), description: 'View statistics for ZSwap exchange.' },
      '/info/pools': { title: t('Pools'), description: 'View statistics for ZSwap exchange.' },
      '/info/tokens': { title: t('Tokens'), description: 'View statistics for ZSwap exchange.' },
      // '/nfts': { basePath: true, title: t('NFT Marketplace') },
      // '/nfts/collections': { basePath: true, title: t('Collections') },
      // '/nfts/activity': { title: t('Activity') },
      // '/profile': { basePath: true, title: t('Profile') },
      // '/coming-soon': { basePath: true, title: t('Coming Soon') },
      // '/founders-nft': { basePath: true, title: t("Founder's NFT") },
    },
    defaultTitleSuffix: t('ZSwap'),
  }
}

export const getCustomMeta = memoize(
  (path: string, t: ContextApi['t'], _: string): PageMeta => {
    const pathList = getPathList(t)
    const pathMetadata =
      pathList.paths[path] ??
      pathList.paths[Object.entries(pathList.paths).find(([url, data]) => data.basePath && path.startsWith(url))?.[0]]

    if (pathMetadata) {
      return {
        title: `${pathMetadata.title} | ${t(pathList.defaultTitleSuffix)}`,
        ...(pathMetadata.description && { description: pathMetadata.description }),
      }
    }
    return null
  },
  (path, t, locale) => `${path}#${locale}`,
)
